import { Routes } from '@angular/router';
import { RouteConstant } from '../../../../../src/app/core/_constants/route.constant';

export const SECURE_ROUTES: Routes = [
    {
        path: `${RouteConstant.Dashboard}`,
        data: { preload: true },
        loadChildren: () => import('../../pages/dashboard/dashboard.module').then(mod => mod.DashboardModule)
    },
    {
        path: `${RouteConstant.Profile}`,
        data: { preload: true },
        loadChildren: () => import('../../pages/profile/profile.module').then(mod => mod.ProfileModule)
    },
    {
        path: `${RouteConstant.Client}`,
        data: { preload: true },
        loadChildren: () => import('../../pages/manage-clients/manage-clients.module').then(mod => mod.ManageClientsModule)
    },
    {
        path: `${RouteConstant.Customer}`,
        data: { preload: true },
        loadChildren: () => import('../../pages/manage-customers/manage-customers.module').then(mod => mod.ManageCustomersModule)
    },
    {
        path: `${RouteConstant.invalidAttempts}`,
        data: { preload: true },
        loadChildren: () => import('../../pages/invalid-login/invalid-login.module').then(mod => mod.InvalidLoginModule)
    },
    {
        path: `${RouteConstant.coaching}`,
        data: { preload: true },
        loadChildren: () => import('../../pages/coaching/coaching.module').then(mod => mod.CoachingModule)
    },
    {
        path: `${RouteConstant.paymentHistory}`,
        data: { preload: true },
        loadChildren: () => import('../../pages/take-payment/take-payment.module').then(mod => mod.TakePaymentModule)
    },
    {
        path: `${RouteConstant.subscription}`,
        data: { preload: true },
        loadChildren: () => import('../../pages/manage-subscription/manage-subscription.module').then(mod => mod.ManageSubscriptionModule)
    },
    // {
    //     path: `${RouteConstant.clientPayment}`,
    //     data: { preload: true },
    //     loadChildren: () => import('../../pages/client-payments/client-payments.module').then(mod => mod.ClientPaymentsModule)
    // },
    {
        path: `${RouteConstant.settings}`,
        data: { preload: true },
        loadChildren: () => import('../../pages/settings/settings.module').then(mod => mod.SettingsModule)
    },
    {
        path: `${RouteConstant.support}`,
        data: { preload: true },
        loadChildren: () => import('../../pages/support/support.module').then(mod => mod.SupportModule)
    },
    {
        path: `${RouteConstant.archive}`,
        data: { preload: true },
        loadChildren: () => import('../../pages/archived/archived.module').then(mod => mod.ArchivedModule)
    },
    {
        path: `${RouteConstant.reporting}`,
        data: { preload: true },
        loadChildren: () => import('../../pages/reporting/reporting.module').then(mod => mod.ReportingModule)
    }
];